var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1765 11.2941C21.1765 13.6332 19.2803 15.5294 16.9412 15.5294C14.6021 15.5294 12.7059 13.6332 12.7059 11.2941C12.7059 8.95502 14.6021 7.05882 16.9412 7.05882C19.2803 7.05882 21.1765 8.95502 21.1765 11.2941Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1176 15.3496V24L16.9412 21.1764L19.7647 24V15.3496C18.9643 15.9079 17.991 16.2353 16.9412 16.2353C15.8913 16.2353 14.918 15.9079 14.1176 15.3496Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52939 3.52942H20.4706V4.94119H3.52939V3.52942Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52939 6.35294H11.2941V7.76471H3.52939V6.35294Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52939 9.17646H11.2941V10.5882H3.52939V9.17646Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52939 12H11.2941V13.4118H3.52939V12Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.82353C0 1.26414 1.26414 0 2.82353 0H21.1765C22.7359 0 24 1.26414 24 2.82353V15.5294C24 17.0888 22.7359 18.3529 21.1765 18.3529H20.4706V16.9412L21.1765 16.9412C21.9562 16.9412 22.5882 16.3091 22.5882 15.5294V2.82353C22.5882 2.04383 21.9562 1.41177 21.1765 1.41177H2.82353C2.04383 1.41177 1.41177 2.04383 1.41177 2.82353V15.5294C1.41177 16.3091 2.04383 16.9412 2.82353 16.9412L13.4118 16.9412V18.3529H2.82353C1.26414 18.3529 0 17.0888 0 15.5294V2.82353Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicense);
export default __webpack_public_path__ + "static/media/License.a1724b3453bb90df7ea223154366c296.svg";
export { ForwardRef as ReactComponent };